// Shared app constants
export const FREE_SHIPPING_THRESHOLD = 75;
export const STANDARD_SHIPPING_COST = 6.99;
export const CHART_HEIGHT = 260;
export const RECENTLY_VIEWED_LIMIT = 8;
